import { useEffect, useState } from 'react'

export default function useIsVisible(ref: React.RefObject<HTMLElement | null>) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    let observer: IntersectionObserver | null = null

    if (ref.current) {
      observer = new IntersectionObserver(([entry]) =>
        setIntersecting(entry.isIntersecting)
      )

      observer.observe(ref.current)
    }

    return () => {
      observer?.disconnect()
    }
  }, [ref])

  return isIntersecting
}
